import {
  PatientProfileInformation,
} from "../../../../domain/patient";
import {
  instanceOfIPatientProfileInformationApplicable, IPatientProfileInformationApplicable,
} from "../../../../domain/document/items";
import {
  IDocumentEditable,
} from "..";

export class PatientProfileApplicator {
  constructor(public source: IDocumentEditable) {
  }

  public apply(info: PatientProfileInformation): void {
    for (let itemSetId = 0; itemSetId < this.source.itemSets.length; ++itemSetId) {
      this.applyToItemSet(info, itemSetId);
    }
  }

  private applyToItemSet(info: PatientProfileInformation, itemSetId: number): void {
    if (itemSetId < 0) { throw new Error("itemSetId is invalid!!!"); }
    const itemSet = this.source.itemSets[itemSetId];
    for (const item of itemSet.items) {
      if (!instanceOfIPatientProfileInformationApplicable(item)) {
        continue;
      }
      const cloned = item.clone() as IPatientProfileInformationApplicable;
      if (!cloned.handlePatientProfileInformationApplied(info)) {
        continue;
      }
      // TODO:文字サイズの下限を下回った時の続紙対応
      cloned.adjustFontSize();
      this.source.updateItem(cloned, {
        itemSetId,
      });
    }
  }
}
